import { render, staticRenderFns } from "./simulationtrading.vue?vue&type=template&id=04f2641b"
import script from "./simulationtrading.vue?vue&type=script&lang=js"
export * from "./simulationtrading.vue?vue&type=script&lang=js"
import style0 from "./simulationtrading.vue?vue&type=style&index=0&id=04f2641b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports